module.exports = __webpack_public_path__ + "media/application/images/features/sales-channels-1100-785b2928f1d665c8ff85616c9ea01637.png";